import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorMistralAgentIdFieldProps {
  control: Control<CryptorFormData, {}>;
  registerKey:
    | "mistralAIAgentIdFR"
    | "mistralAIAgentIdEN"
    | "mistralAIAgentIdES"
    | "mistralAIAgentIdDE"
    | "mistralAIAgentIdHU"
    | "mistralAIAgentIdIT"
    | "mistralAIAgentIdNL"
    | "mistralAIAgentIdPL"
    | "mistralAIAgentIdPT";
  label: string;
}

const CryptorMistralAgentIdField: FC<CryptorMistralAgentIdFieldProps> = ({
  control,
  registerKey,
  label,
}) => {
  return (
    <Controller
      control={control}
      name={registerKey}
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label={label}
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorMistralAgentIdField;
